export default {
  users: [],
  user: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
